export const findWhere = (array, criteria)  => {
  return array.find(function(obj){
    var criteriaProp = Object.keys( criteria )[ 0 ];
    return obj[criteriaProp] === criteria[criteriaProp]
  });
}